import { render, staticRenderFns } from "./WxpublicSet.vue?vue&type=template&id=76629ca8"
import script from "./WxpublicSet.vue?vue&type=script&lang=js"
export * from "./WxpublicSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports